// // const API_BASE = "assocham.org/api";

// // export async function fetchSectorBySlug(slug) {
// //   if (!slug) return null;

// //   try {
// //     const res = await fetch(
// //       `${API_BASE}/get_sector.php?slug=${encodeURIComponent(slug)}`
// //     );
// //     if (!res.ok) return null;

// //     const json = await res.json();
// //     return json.success ? json : null;
// //   } catch (err) {
// //     console.error("fetchSectorBySlug failed:", err);
// //     return null;
// //   }
// // }


// const API_BASE = "https://assocham.org/api"; // jo base URL events/press me use ho raha hai wahi

// export async function fetchSectorBySlug(slug) {
//   const res = await fetch(`${API_BASE}/get_sector.php?slug=${encodeURIComponent(slug)}`);
//   const json = await res.json();
//   if (!json.success) {
//     throw new Error(json.message || "Sector not found");
//   }
//   return json.data;
// }




// new code 




const API_BASE = "https://assocham.org/api";

export async function fetchSectorBySlug(slug) {
  const res = await fetch(`${API_BASE}/get_sector.php?slug=${encodeURIComponent(slug)}`);
  const json = await res.json();
  if (!json.success) {
    throw new Error(json.message || "Sector not found");
  }
  return json.data;
}



export async function fetchSectorEvents(slug) {
  if (!slug) return [];

  try {
    const res = await fetch(`${API_BASE}/get_sector_events.php?slug=${encodeURIComponent(slug)}`);
    const json = await res.json();
    if (!json.success) return [];
    return json.data || [];
  } catch (err) {
    console.error("fetchSectorEvents error:", err);
    return [];
  }
}